module.exports = __webpack_public_path__ + "media/components/riskregister/icons/operations-0ee70d1fa1353f8c2d2d96f96994b4dc.png";